import React from "react";
import { AiOutlineClockCircle, AiOutlineMail } from "react-icons/ai";
import { FiPhoneCall } from "react-icons/fi";
const CompanyInfo = () => {
  const Infoemail = "info@rwdynamics.com";
  const InfomailtoLink = `mailto:${Infoemail}`;
  return (
    <div className="md:flex block items-center justify-between md:mx-32 py-8">
      {/* First Item */}
      <div className="flex justify-center text-black items-center my-5 space-x-3">
        {/* Icon */}
        <div>
          <AiOutlineClockCircle size={60} />
        </div>
        <div>
          {/* Title */}
          <h1 className="font-bold">Working Hours</h1>
          {/* Desc */}
          <p className="font-light text-sm">24 Hours/ 7 Days</p>
          {/* <p className="font-light text-sm">Monday to Friday</p>
          <p className="font-light text-sm">8:00am-5:00pm</p> */}
        </div>
      </div>
      {/* Second Item */}
      <div className="flex justify-center text-black items-center space-x-3 my-5">
        {/* Icon */}
        <div>
          <FiPhoneCall size={60} />
        </div>
        <div>
          {/* Title */}
          <h1 className="font-bold">Call Us</h1>
          {/* Desc */}
          <p className="font-light text-sm">+2348033917294</p>
        </div>
      </div>
      {/* Third Item */}
      <div className="flex justify-center text-black items-center space-x-3 my-5">
        {/* Icon */}
        <div>
          <AiOutlineMail size={60} />
        </div>
        <div>
          {/* Title */}
          <h1 className="font-bold">Mail Us</h1>
          {/* Desc */}
          <p className="font-light text-sm">
            <a href={InfomailtoLink} target="_blank">
              info@rwndynamics.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;
